import React, { useCallback, useState } from "react"
import { AppBar, Grid, IconButton, makeStyles, Toolbar } from "@material-ui/core"
import { WellknownHeight } from "../../../../Helpers/constants"
import { SafeArea } from "../../../../Components/Skeleton/SafeArea"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useAppNavigation } from "../../../../hooks/useAppNavigation"
import { faTimes } from "@fortawesome/pro-regular-svg-icons"
import { LocalizedStrict } from "../../../Localization/Components/Localized"
import { ConfirmationDialog } from "../../../../Components/Dialog/ConfirmationDialog"
import { resetMeetingData } from "../../Redux/MeetingPlanningActions"
import { Dispatch } from "redux"

const useTopBarStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.common.white,
    },
    spacer: {
        paddingBottom: WellknownHeight.PRIMARY_TOP_BAR,
    },
    plug: {
        minWidth: '1.9rem'
    }
}))

interface ITopBarProps {
    dispatch: Dispatch
    middleElement?: React.ReactNode
}

enum ActionDialog {
    None = "None",
    ConfirmCancel = "ConfirmCancel",
}

type ConfirmCancelProps = Readonly<{
    open: boolean
    onClose: () => void
    onConfirm: () => void
}>

function ConfirmCancelModal({ open, onClose, onConfirm }: ConfirmCancelProps) {
    return (
        <LocalizedStrict id="cancel-delivery" attrs={{ description: true, confirmLabel: true, cancelLabel: true, loadingDescription: true }}>
            <ConfirmationDialog
                description="Ønsker du at annullere nuværende ordre?"
                confirmLabel="Ja"
                cancelLabel="Nej"
                open={open}
                onClose={onClose}
                onConfirm={onConfirm}
            />
        </LocalizedStrict>
    )
}

export const AddDeliveryTopBar = ({ dispatch, middleElement }: ITopBarProps) => {
    const classes = useTopBarStyles()
    const { goToHome } = useAppNavigation()

    const [openDialog, setOpenDialog] = useState(ActionDialog.None)

    const handleConfirmCancelDelivery = useCallback(() => {
        setOpenDialog(ActionDialog.ConfirmCancel)
    }, [goToHome])

    const handleCancelDelivery = useCallback(() => {
        dispatch(resetMeetingData());
        goToHome()
    }, [])

    return <>
        <AppBar position="fixed" className={classes.root}>
            <Toolbar>
                <SafeArea top position="relative">
                    <Grid container direction="column">
                        <Grid item container justifyContent="space-between"  alignItems="center">
                            <Grid item>
                                <IconButton onClick={handleConfirmCancelDelivery} edge="start" color="inherit" aria-label="menu">
                                    <FontAwesomeIcon icon={faTimes} color="black" size={"1x"} />
                                </IconButton>
                            </Grid>

                            <Grid item>{middleElement}</Grid>

                            <Grid item className={classes.plug} />
                        </Grid>
                    </Grid>
                </SafeArea>
            </Toolbar>
        </AppBar>
        {openDialog && (
            <ConfirmCancelModal
                open={openDialog === ActionDialog.ConfirmCancel}
                onClose={() => setOpenDialog(ActionDialog.None)}
                onConfirm={handleCancelDelivery}
            />
        )}
        <Toolbar className={classes.spacer} />
    </>
}
